import React from "react";
import { Button, Card, CardActions, CardContent, IconButton } from "@material-ui/core";
import EventLabel2 from "../../../../components/EventLabel2/EventLabel2";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { Question } from "./Question";
import { combineProps } from "../../../../helpers/objectHelper";
import { AnswerSentAlert } from "./AnswerSentAlert";
import { NoQuestionPlaceholder } from "./NoQuestionPlaceholder";

export function PollModuleContainer(props) {
  const { questionList, togglePage, pageNo, valid, answerList, send, pollTemplate, sent, preview } = props;

  const { pagination, sendButton, frame } = pollTemplate;
  const question = questionList.length ? (questionList[pageNo - 1] ? questionList[pageNo - 1].question : {}) : {};

  const { questionId } = question;
  const answer = answerList.find((nl) => nl.questionId == questionId);
  const validateOptionQuestion = () => {
    if (!question) return false;
    let len = answerList.filter((a) => a.questionId == question.questionId).length;
    if (question && question.requiredMin !== null && question.requiredMin > 0) {
      if (len < question.requiredMin) {
        return false;
      }
    }
    if (question && question.requiredMax !== null && question.requiredMax > 0) {
      if (len > question.requiredMax) {
        return false;
      }
    }
    return true;
  };

  let isValid = false;
  const questionType = question ? question.type : null;
  if (questionType == "Option") {
    isValid = validateOptionQuestion();
  } else if (questionType == "Text") {
    isValid = answer ? answer.valid : false;
  } else {
    isValid = false;
  }
  return (
    <Card variant="outlined" style={{ ...frame, height: "100%" }}>
      <CardContent
        component="div"
        style={{
          display: "flex",
          position: "relative",
          flexDirection: "row",
          height: "calc(100% - 46px)",
          padding: 8,
          paddingBottom: 0,
        }}
      >
        <AnswerSentAlert {...props} />
        {questionList.length > 0 ? <Question {...combineProps([props, { type: questionType }])} /> : <NoQuestionPlaceholder {...props} />}
      </CardContent>
      {questionList.length > 0 ? (
        <CardActions>
          <div style={{ display: "flex", width: "100%" }}>
            {questionList.length > 1 ? (
              <div style={{ width: "50%" }} className="text-left">
                <IconButton onClick={() => togglePage(pageNo - 1)} style={{ color: pagination.stepColor }} disabled={pageNo == 1} size="small">
                  <ChevronLeftIcon />
                </IconButton>
                <span style={{ ...pagination, color: pagination.textColor }}>{`${pageNo} / ${questionList.length}`}</span>

                <IconButton onClick={() => togglePage(pageNo + 1)} style={{ color: pagination.stepColor }} disabled={pageNo == questionList.length} size="small">
                  <ChevronRightIcon />
                </IconButton>
              </div>
            ) : (
              <div style={{ width: "50%" }} className="text-left" />
            )}
            <div style={{ width: "50%" }} className="text-right">
              <Button size="small" disabled={!isValid || preview} style={{ ...sendButton, padding: "3px 8px" }} onClick={() => send(questionId)}>
                <EventLabel2 name="Send" groupName="DigitalMeeting.Client" />
              </Button>
            </div>
          </div>
        </CardActions>
      ) : null}
    </Card>
  );
}
